export class DropdownValueConverter {
	toView(name: string) {
		return `activates: dropdown${name}; cover-trigger: false;`;
	}
}